// extracted by mini-css-extract-plugin
module.exports = {"bg":"shared-hosting-offer-card_bg__q9Zow"};